import type { PreOrderSuggestion } from "@stockline/shared/types/ai/pre-order-suggestion"
import { PRE_ORDER_SUGGESTION_TABLE } from "../../../lib/offline/resources/ai/pre-order-suggestion/db"
import { useAISync } from "../providers/AISyncProvider"

/**
 * AI header suggestions, optionally scoped to one committed pre-order
 * (`targetId`). Ordered by `syncId` so the latest proposal is last.
 * Callers filter pending (`acceptedAt == null && declinedAt == null`) and
 * `deletedAt` themselves.
 */
export function usePreOrderSuggestions(
  targetId?: string
): PreOrderSuggestion[] {
  const { reactive } = useAISync()
  return reactive.useQuery<PreOrderSuggestion>(PRE_ORDER_SUGGESTION_TABLE, {
    ...(targetId ? { targetId } : {}),
    orderBy: "syncId",
  })
}
